import React, { useState, useEffect } from 'react';
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';

import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User';
import axios from 'axios';
import swal from 'sweetalert';
import Alert from '../shared/Utils/AlertBox';
import moment from 'moment';
import { HubConnectionBuilder } from "@microsoft/signalr";
import { useSearchParams } from "react-router-dom";

export default function SequenceDetail() {

  const [sequenceDetail, setSequenceDetail] = useState([])
  const [accountID, setaccountID] = useState(0);
  const [loader, setLoader] = useState(false);
  const [connectionID, setconnectionID] = useState(0)
  const [connection, setConnectionn] = useState(new HubConnectionBuilder().withUrl("https://api.getbound.ai/api/socket").build())
  const [step1, setStep1] = useState(false);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);
  const [socketData, setsocketData] = useState({})
  const [verificationCode, setVerificationCode] = useState("")
  const [searchParams, setSearchParams] = useSearchParams();

  const [inputValue, setInputValue] = useState({ email: "", name: "", website: "" });
  const { email, name, website } = inputValue;

  const user = User.getUser()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  useEffect(() => {
    getSeuqnceDetail();

    connection.start().then(() => {
      setconnectionID(connection.connectionId)
      connection.on('authorization_response', data => {
        data['client_connection_id'] = connection.connectionId;
        if (data.status == 3) {
          setStep1(true);
          setStep2(false);
          setStep3(true);
          getSeuqnceDetail();
          return;
        }
        else if (data.status == 2) {
          setStep1(false);
          setStep2(true);
          let p = {
            'client_connection_id': data.connection_id,
            'connection_id': connection.connectionId,
            'platform_id': data.platform_id
          };
          setsocketData(p);
        }
        else if (data.status == 4) {
          setStep1(false);
          setStep2(false);
          setStep3(false);
          setStep4(true);
        }

      })
    })

  }, [])

  const getSeuqnceDetail = () => {
    let arr = [];
    arr.push({ P_id: searchParams.get("sequence_id") });
    arr.push({ P_type_id: 1 });

    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/agent/getSequenceDetail?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setSequenceDetail(response.data.data);
      } else {
        swal({
          title: "Error!",
          text: response.data.msg,
          icon: "error",
          button: "Ok",
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function Verify(id) {
    let requestData = new FormData();
    let arr = [];
    arr.push({ P_platform_id: id });
    arr.push({ P_connection_id: connectionID });
    arr.push({ P_user_id: user[0].Id });
    let p = SerializeClass.getSerializedData(arr);
    let rurl = `/api/user/AddAuthorizationRequest`;
    requestData.append('Params', p);
    setStep1(true);
    HttpCall.postRequest2(rurl, requestData).then(response => {
      if (response.data.code == 200) {

        //Alert.show( "Success!",  "Request Initiated for the verification", "success");
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      setStep1(false);
    })
  }

  function sendCodeRequest() {
    console.log(socketData);
    socketData['code'] = verificationCode;
    console.log(socketData);
    let p = socketData;
    p['code'] = verificationCode;
    setStep1(true);
    setStep2(false);
    HttpCall.postRequest2('/api/live/socket/authRequest', p).then(response => {
      setVerificationCode("");
    }).catch(err => {
      console.log(err);
      setLoader(false);
    })
  }

  function closePopup() {
    setStep1(false);
    setStep2(false);
    setStep3(false);
    setStep4(false);
  }

  return (
    <>
      <DashboardHeader />
      <div className="container-fluid page-body-wrapper">

        <SideMenu />

        {step1 && <div id="RequestModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            {/* <span class="close1 closebtn">&times;</span> */}
            <i class="mdi mdi-timer-sand"></i>
            <h1>Processing Verification Request...</h1>
            <h2>This may take a while</h2>
            {/* <button type="button" class="btn btn-primary btn-rounded btn-md">OK</button> */}
          </div>
        </div>}

        {step2 && <div id="VerificationCode" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <i class="mdi mdi-link-variant"></i>
            <h1>Enter the verification code</h1>
            <input type="text" class="text-center form-control form-control-lg"
              id="exampleInputPassword1" placeholder="XXXXXXXX" suggesstion="off"
              name="verificationCode" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} />
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={sendCodeRequest}>OK</button>
          </div>
        </div>}

        {step3 && <div id="SuccessfullyModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <span class="close3 closebtn">&times;</span>
            <i class="mdi mdi-checkbox-marked-circle-outline"></i>
            <h1>Your account has been Successfully Verified!</h1>
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
          </div>
        </div>}

        {step4 && <div id="FailModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <span class="close3 closebtn">&times;</span>
            <i class="mdi mdi-alert-circle-outline"></i>
            <h1>Please check your credentials and try again!</h1>
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
          </div>
        </div>}

        <div className="main-panel">
          <div class="content-wrapper">
            <div class="row">

              <div class="col-md-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Sequence Detail</h4>
                    <p class="card-description">
                      Note: Detail Sequence Report
                    </p>

                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Status</th>
                            <th>Total Lead List Records</th>
                            <th>Message/Email Sent</th>
                            <th>Replies</th>
                            {/* <th>Remaining</th>
                            <th>Agent Name</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {sequenceDetail.length > 0 && sequenceDetail[0].data.map((data, index) => (<tr key={index}>
                            <td>
                              <button type="button" class="btn btn-primary btn-sm">{data.status_name}</button>
                            </td>
                            {/* <td><a href={'/sequence-report?sequence_id=' + searchParams.get("sequence_id")}>{data.lead_list_records}</a></td> */}
                            <td>{data.lead_list_records}</td>
                            <td>{data.message_sent}</td>
                            <td>{data.replied}</td>
                          </tr>))}

                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>



              <div class="col-md-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <form class="forms-sample">


                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Customer Name</label>
                            <input type="text" class="form-control form-control-lg custominputname" value={sequenceDetail.length > 0 && sequenceDetail[0].data[0].customer_name} disabled />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Sequence Name</label>
                            <input type="text" class="form-control form-control-lg" placeholder="Sequence Name" value={sequenceDetail.length > 0 && sequenceDetail[0].data[0].sequence_name} disabled />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Sequence Created Date</label>
                            <input type="text" disabled class="form-control form-control-lg" placeholder="Sequence Created At Date" value={sequenceDetail.length > 0 && moment(sequenceDetail[0].data[0].created_on).format('DD-MMM-YYYY')} />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="exampleInputEmail1">Sequence Template</label>
                            <textarea disabled class="form-control form-control-lg customtextarea" placeholder="Enter Description of the Sequence" rows="20" value={sequenceDetail.length > 0 && sequenceDetail[0].data[0].sequence_template}></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="row">

                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Sequence Template Source File</label><br/>


                            
                            {/* <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Brandon Washington.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Laura Brooks.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Wayne Murphy.xls</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Matthew Bailey.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Katherine Butler.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Jack William.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Leo Lucas.png</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Thomas Henry.txt</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Quarterly Report.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Matthew Bailey.docx</a></div> */}



                            {sequenceDetail.length > 0 && sequenceDetail[2].data.map((data) => (
                              // <p><a href={"https://content.getbound.ai/sequence_template/" + data.file_path}>{data._file_name}</a></p>
                              <div class="badge badge-opacity-success me-3 customfilebadge"><a href={"https://content.getbound.ai/sequence_template/" + data.file_path}>{data._file_name}</a></div>
                              ))}


                          </div>
                        </div>


                        {/* <div class="col-md-12">
                          <div class="form-group">
                            <label>Lead List Template Source File</label><br/>

                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Brandon Washington.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Laura Brooks.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Wayne Murphy.xls</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Matthew Bailey.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Katherine Butler.docx</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Jack William.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Leo Lucas.png</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Thomas Henry.txt</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Quarterly Report.pdf</a></div>
                            <div class="badge badge-opacity-success me-3 customfilebadge"><a href="#">Matthew Bailey.docx</a></div>

                          </div>
                        </div> */}



                      </div>




                    </form>

                  </div>
                </div>
              </div>


              <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Platform Details</h4>

                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>User ID</th>
                            <th>Url</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sequenceDetail.length > 0 && sequenceDetail[1].data.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.login_id}</td>
                            <td>{data._url}</td>
                            <td>
                              <label onClick={() => data.is_verified == 1 ? undefined : Verify(data.id)} class={data.is_verified == 1 ? "btn btn-success btn-sm savebtn" : "btn btn-danger btn-sm savebtn"}>{(data.is_verified == 0 ? 'Verify' : 'Verified')}
                              </label>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>

  )
}